module.exports = __webpack_public_path__ + "static/Q3_2022_Announcement_Financial_Results-3e91e4321256aaeea2f1b500a9bfc252.pdf";